import { FlexBox } from "@brg/ui";
import { FC, useCallback, useMemo } from "react";
import styled from "styled-components";
import { CommonCheckbox } from "../CommonCheckbox/CommonCheckbox";
import { useTranslation } from "react-i18next";
import { useController } from "react-hook-form";
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import urlApi from "shared/actions/urlApi";
import { AppTester } from "supporting";
import { LayoutConst } from "../../../core";
import { BookType } from "_deziiign/books/constants";

const Container = styled(FlexBox).attrs({
    className: 'annotation-field_container'
})`
  flex-flow: column;
`;

const AnnotationField: FC = () => {
    const { t } = useTranslation();
    const isGeograffee = AppTester.isGeograffee();
    const isStart = AppTester.isStartHSE()
    const { field: {value: additionalContent, onChange: onSetAddContent } } = useController({ name: 'additionalContent' });
    const { field: {value: moderationType } } = useController({ name: 'moderationType' });
    const { field: { onChange: onUpdateTrigger } } = useController({ name: 'updateTrigger' })
    const { field: {value: isBook } } = useController({ name: 'isBook' });
    const { field: {value: bookType } } = useController({ name: 'bookType' });
    const { field: {value: includesPosts } } = useController({ name: 'includesLongreadPosts' });

    const annotationPost = useMemo(() => {
        return !!includesPosts?.length && includesPosts?.find((post: any) => post?.name === 'annotation')
    } , [includesPosts])

    const isCourseProject = useMemo(() => {
        return (moderationType && moderationType?.value === ModerationType.LMS)
    } , [moderationType])

    const canChangeChecked = useMemo(() => {
        if (isCourseProject || isStart) return false;
        return true;
    } , [moderationType, isStart, isCourseProject])

    const checked = useMemo(() => {
        if (isCourseProject || isStart) return true;
        return !!additionalContent?.annotation?.visible
    } , [additionalContent, isCourseProject])

    const onUpdateLongreadBlocks = () => {
        setTimeout(() => onUpdateTrigger(Date.now()), 100)
        setTimeout(() => onUpdateTrigger(undefined), 200)
    }

    const onDeleteAnnotationPost = async () => {
        if (!annotationPost) return;
        await urlApi?.()?.deleteLgPost(annotationPost?.id)?.finally(onUpdateLongreadBlocks)
    }

    const onChange = useCallback(() => {
        if (!canChangeChecked) return;
            onSetAddContent({
                ...(additionalContent ? additionalContent : {}),
                annotation: { visible: !checked }
            })
            onDeleteAnnotationPost();
    } , [additionalContent, canChangeChecked, annotationPost, checked])

    if (!!isBook) return null;

    return (
        <Container>
            <CommonCheckbox
                label={t('project_edit.navigation.annotation_block')}
                checked={checked}
                dark={!isGeograffee}
                disabled={!canChangeChecked}
                // hintText={t("hints.anchor")}
                onClick={onChange}
            />
        </Container>
    )
}

export default AnnotationFieldimport { FlexBox } from "@brg/ui";
import { FC, useCallback, useMemo } from "react";
import styled from "styled-components";
import { CommonCheckbox } from "../CommonCheckbox/CommonCheckbox";
import { useTranslation } from "react-i18next";
import { useController } from "react-hook-form";
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import urlApi from "shared/actions/urlApi";
import { AppTester } from "supporting";
import { LayoutConst } from "../../../core";
import { BookType } from "_deziiign/books/constants";

const Container = styled(FlexBox).attrs({
    className: 'annotation-field_container'
})`
  flex-flow: column;
`;

const AnnotationField: FC = () => {
    const { t } = useTranslation();
    const isGeograffee = AppTester.isGeograffee();
    const isStart = AppTester.isStartHSE()
    const { field: {value: additionalContent, onChange: onSetAddContent } } = useController({ name: 'additionalContent' });
    const { field: {value: moderationType } } = useController({ name: 'moderationType' });
    const { field: { onChange: onUpdateTrigger } } = useController({ name: 'updateTrigger' })
    const { field: {value: isBook } } = useController({ name: 'isBook' });
    const { field: {value: bookType } } = useController({ name: 'bookType' });
    const { field: {value: includesPosts } } = useController({ name: 'includesLongreadPosts' });

    const annotationPost = useMemo(() => {
        return !!includesPosts?.length && includesPosts?.find((post: any) => post?.name === 'annotation')
    } , [includesPosts])

    const isCourseProject = useMemo(() => {
        return (moderationType && moderationType?.value === ModerationType.LMS)
    } , [moderationType])

    const canChangeChecked = useMemo(() => {
        if (isCourseProject || isStart) return false;
        return true;
    } , [moderationType, isStart, isCourseProject])

    const checked = useMemo(() => {
        if (isCourseProject || isStart) return true;
        return !!additionalContent?.annotation?.visible
    } , [additionalContent, isCourseProject])

    const onUpdateLongreadBlocks = () => {
        setTimeout(() => onUpdateTrigger(Date.now()), 100)
        setTimeout(() => onUpdateTrigger(undefined), 200)
    }

    const onDeleteAnnotationPost = async () => {
        if (!annotationPost) return;
        await urlApi?.()?.deleteLgPost(annotationPost?.id)?.finally(onUpdateLongreadBlocks)
    }

    const onChange = useCallback(() => {
        if (!canChangeChecked) return;
            onSetAddContent({
                ...(additionalContent ? additionalContent : {}),
                annotation: { visible: !checked }
            })
            onDeleteAnnotationPost();
    } , [additionalContent, canChangeChecked, annotationPost, checked])

    if (!!isBook) return null;

    return (
        <Container>
            <CommonCheckbox
                label={t('project_edit.navigation.annotation_block')}
                checked={checked}
                dark={!isGeograffee}
                disabled={!canChangeChecked}
                // hintText={t("hints.anchor")}
                onClick={onChange}
            />
        </Container>
    )
}

export default AnnotationField